import type { UserResponse } from '@@/types/api';

export function userDisplayName(user: UserResponse): string {
  const parts = [user.first_name, user.last_name].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : user.username;
}

export function userAvatarUrl(
  user: UserResponse,
  size: 64 | 128 | 256 = 128,
): string {
  if (user.photo_base_url) {
    return `${user.photo_base_url}/${size}.png`;
  }
  return user.gravatar_url;
}

export function userInitials(user: UserResponse): string {
  if (user.first_name && user.last_name) {
    return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();
  }
  if (user.first_name) return user.first_name.charAt(0).toUpperCase();
  if (user.last_name) return user.last_name.charAt(0).toUpperCase();
  return user.username.charAt(0).toUpperCase();
}
